import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  FormControl,
  Input,
  Modal,
  ModalClose,
  Typography,
  Sheet,
  Box,
  Textarea,
} from "@mui/joy";
import toast from "react-hot-toast";
import axiosInstance from "../../api/axios";
import AuthContext from "../../contexts/authContext";

export default function AddAsset({
  openAsset,
  setOpenAsset,
  setAssetId,
  assetId,
  setEditMode,
  editMode,
}) {
  const { userData, setRefresh } = useContext(AuthContext);
  const [form, setForm] = useState({
    name: "",
    mobile: "",
    email: "",
    address: "",
  });

  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { name, mobile, email, address } = form;
    if (mobile.length !== 10) {
      toast.error("Mobile number must be 10 digits.");
      return;
    }
    if (!name || !mobile || !email || !address) {
      toast.error("All fields are required.");
      return;
    }

    try {
      const res = await axiosInstance.post("/asset/add", {
        companyName: name,
        mobile,
        email,
        address,
        added_by: localStorage.getItem("userId"),
      });

      if (res.status === 200) {
        toast.success("Assets added successfully!");
        setForm({
          name: "",
          mobile: "",
          email: "",
          address: "",
        });
        setOpenAsset(false);
        setRefresh(true);
      }
    } catch (err) {
      toast.error("An error occurred while adding the Assets.");
    }
  };
  const handleEditAsset = async (e) => {
    e.preventDefault();
    if (form.mobile.length !== 10) {
      toast.error("Mobile number must be 10 digits.");
      return;
    }
    try {
      const res = await axiosInstance.post(`/asset/edit/${assetId}`, {
        companyName: form.name,
        mobile: form.mobile,
        email: form.email,
        address: form.address,
      });

      if (res.status === 200) {
        toast.success("Asset updated successfully!");
        setOpenAsset(false);
        setAssetId("");
        setRefresh(true);
        setEditMode(false);
      }
    } catch (err) {
      toast.error("An error occurred while updating the user.");
    }
  };
  const handleCloseAssetModal = () => {
    setForm({
      name: "",
      mobile: "",
      email: "",
      address: "",
    });
    setAssetId("");
    setEditMode(false);
    setOpenAsset(false);
  };
  useEffect(() => {
    if (assetId) {
      setEditMode(true);
      const editAsset = userData?.assets?.find((ite) => ite._id === assetId);
      if (editAsset) {
        setForm({
          name: editAsset.companyName || "",
          mobile: editAsset.mobile || "",
          email: editAsset.email || "",
          address: editAsset.address || "",
        });
      }
    } else {
      setEditMode(false);
      setForm({
        name: "",
        mobile: "",
        email: "",
        address: "",
      });
      setAssetId("");
    }
  }, [assetId, userData]);

  return (
    <Modal
      open={openAsset}
      onClose={handleCloseAssetModal}
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <Sheet
        variant="outlined"
        sx={{
          maxWidth: 500,
          width: "100%",
          bgcolor: "#FEDDDD",
          p: 4,
          borderRadius: "md",
          boxShadow: "lg",
          maxHeight: "90vh",
          overflowY: "auto",
          m: 2,
        }}
      >
        <ModalClose
          sx={{
            m: 1,
            "& svg": { color: "#800001" },
            "&:hover": {
              backgroundColor: "#800001",
              "& svg": { color: "#fff" },
            },
          }}
          onClick={() => setOpenAsset(false)}
        />

        <Typography
          level="h4"
          sx={{
            color: "#800001",
            fontWeight: "bold",
            mb: 2,
            textAlign: "center",
          }}
        >
          {editMode ? "Edit Asset" : "Add Asset"}
        </Typography>

        <form
          onSubmit={editMode ? handleEditAsset : handleSubmit}
          style={{ overflowY: "auto" }}
        >
          <FormControl sx={{ mb: 2 }}>
            {/* <FormLabel>Name</FormLabel> */}
            <Input
              placeholder="Company Name"
              name="name"
              value={form.name}
              onChange={handleChange}
              required
            />
          </FormControl>

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: { xs: 0, sm: 2 },
            }}
          >
            <FormControl sx={{ mb: 2, flex: 1 }}>
              {/* <FormLabel>Mobile</FormLabel> */}
              <Input
                placeholder="Phone"
                name="mobile"
                value={form.mobile}
                onChange={handleChange}
                required
              />
            </FormControl>

            <FormControl sx={{ mb: 2, flex: 1 }}>
              {/* <FormLabel>Email</FormLabel> */}
              <Input
                placeholder="Email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
              />
            </FormControl>
          </Box>

          <FormControl sx={{ mb: 2 }}>
            {/* <FormLabel>Address</FormLabel> */}
            <Textarea
              placeholder="Address"
              minRows={2}
              name="address"
              value={form.address}
              onChange={handleChange}
              required
            />
          </FormControl>

          <Button
            type="submit"
            fullWidth
            variant="solid"
            sx={{
              mt: 3,
              backgroundColor: "#800001",
              color: "white",
              "&:hover": {
                backgroundColor: "#800001",
                color: "#fff",
              },
            }}
          >
            Submit
          </Button>
        </form>
      </Sheet>
    </Modal>
  );
}
